export const LinkRateSpecificRule = [
    { label: 'Increase Rate', value: 'increase' },
    { label: 'Decrease Rate', value: 'decrease' },
];